<template>
    <v-container class="pa-0 ma-0" fluid flat style="width: 100%">
        <v-card flat color="#FFD375">
            <v-container class="pa-2 ma-2" style="height: 5%;">
                <v-row class="pa-0 ma-0">
                    <v-col cols="3">
                        <v-container class="py-0 my-0">
                            <v-row class="py-0 my-0">
                                <div class="text-center px-10 py-0 my-0">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-btn :disabled=noContacts color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>

            <v-card class="pa-0 ma-0" flat style="width: 600px" tile>
                <v-list :key="this.$store.state.updatecount" two-line class="bckgrnd pa-0 ma-0" flat>
                    <v-content>
                        <v-list-item-group v-model="item" color="#FFD375">
                            <v-list-item v-for="(contact, i) in contacts" :key="i">
                                <v-row :class='rowClass(contact)' @click='rowClicked(contact)'>
                                    <v-col cols="8">
                                        <v-list-item-content>
                                            <v-list-item-title class="boldtext" v-text="contact.Name"></v-list-item-title>
                                            <v-list-item-subtitle class="smalltext" v-text="groupCount(contact)"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="4" class="text-right">
                                        <v-container>
                                            <v-list-item-icon class="px-2 py-0 ma-0" v-if="showReminder(contact)" @click='reminderClicked(contact)'>
                                                <img src="assets/reminder.png" height="20" width="20">
                                            </v-list-item-icon>
                                            <v-list-item-icon class="pa-0 ma-0" v-if="contact.IsSelected" @click='editClicked(contact)'>
                                                <v-icon color="#000000">edit</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon class="pa-0 ma-0" v-if="contact.IsSelected" @click='manageClicked(contact)'>
                                                <v-icon color="#000000">account_tree</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon class="pa-0 ma-0" v-if="contact.IsSelected" @click='deleteClicked(contact)'>
                                                <v-icon color="#000000">delete_forever</v-icon>
                                            </v-list-item-icon>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-group>
                    </v-content>
                </v-list>
            </v-card>

            <ContactPopup v-bind:selectedcontact=selectedcontact v-model="showContactPopup" />
            <ContactGroupsPopup v-bind:contact=selectedcontact v-model="showContactGroupsPopup" />
        </v-card>
    </v-container>
</template>

<script>

    import ContactPopup from '@/views/Manage/Contacts/ContactPopup';
    import ContactGroupsPopup from '@/views/Manage/Contacts/ContactGroupsPopup';
    import { elapsedstring, callcloudfunction } from '@/functions.js';

    export default {
        data: () => ({
            sortitems: [
                { title: 'Name A..Z', prop: 'Name', dir: 'Up'},
                { title: 'Name Z..A', prop: 'Name', dir: 'Down' }
            ],
            sorttitle: 'Sort...',
            item: null,
            groupdata: {},
            selectedcontact: null,
            showContactPopup: false,
            showContactGroupsPopup: false
        }),
        components: {
            ContactPopup,
            ContactGroupsPopup
        },
        methods: {
            setSort(param) {
                this.sorttitle = "Sort by " + param.title;
                if (param.dir === 'Up')
                    this.contacts.sort((a, b) => a[param.prop] < b[param.prop] ? -1 : 1);
                else
                    this.contacts.sort((a, b) => a[param.prop] > b[param.prop] ? -1 : 1);
            },
            rowClicked(contact) {
                if (this.selectedcontact != null)
                    this.selectedcontact.IsSelected = false;
                contact.IsSelected = true;
                this.selectedcontact = contact;
                this.$store.state.selectedcontact = contact;
            },
            editClicked(contact) {
                alert("editClicked to do");
                this.showContactPopup = true;
            },
            reminderClicked(contact) {
                callcloudfunction("sendMail", "remind", { email: contact.Email, invitor: this.$store.state.currentuser.Name, invitoremail: this.$store.state.currentuser.Email }, this, "");  
           },
            deleteClicked(contact) {
                this.$root.$confirm('Confirm', 'Are you sure you want to delete this contact?', { color: '#FFA500' }).then((confirm) => {
                    if (confirm) {
                        this.$store.dispatch('cutContact', contact);
                    }
                })
            },
            manageClicked(contact) {
                this.showContactGroupsPopup = true;
            },
            rowClass(contact) {
                if (contact.IsSelected)
                    return 'selectedtile';
                else {
                    if (contact.Registered == null)
                        return 'unregisteredtile';
                    else
                        return 'registeredtile';
                }
            },
            showReminder(contact) {
                if ((contact.Registered == null) && (contact.IsSelected)) {
                    return true;
                }
                else {
                    return false;
                }
            },
            groupCount(contact) {
                var str = "";
                if (contact.Groups == null)
                    str = '(Member of 0 groups)';
                else if (contact.Groups.length == 1)
                    str = '(Member of 1 group)';
                else 
                    str = '(Member of ' + contact.Groups.length + ' groups)';
                if (contact.Registered == null) {
                    str = str + " UNREGISTERED for ";
                    var elapsed = elapsedstring(contact.ID);
                    if (elapsed.length > 0) {
                        str = str + " " + elapsed;
                    }
                }
                return str;
            }
        },
        computed: {
            noContacts() {
                if (!this.contacts)
                    return true;
                if (this.contacts.length < 1)
                    return true;
                else
                    return false;
            },
            contacts() {
                return this.$store.state.contacts;
            }
        }
    }
</script>

<style scoped>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFA500;
        }

        .tile:active {
            background: #FFD375;
        }

    .registeredtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #86F499;
    }

        .registeredtile:hover {
            background: #FFA500;
        }

        .registeredtile:active {
            background: #FFD375;
        }

    .unregisteredtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #F49C86;
    }

        .unregisteredtile:hover {
            background: #FFA500;
        }

        .unregisteredtile:active {
            background: #FFD375;
        }
    .selectedtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .bckgrnd {
        background: #FFD375;
    }

    .boldtext{
        color:black;
        font-size:large;
        font-weight:bold;
    }

    .smalltext{
        color:darkslategray;
        font-size:small;
        margin-top:4px;
    }
</style>

